import { memo, ReactNode, useCallback } from 'react'

import { batikalColor, sectionColors } from '@batical/design'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useIsWebPremium } from 'src/utils/webPremium'

type Props = {
  children: ReactNode
}

const RequireSubscription = ({ children }: Props) => {
  const isPremium = useIsWebPremium()
  const navigate = useNavigate()
  const handleClose = useCallback(() => {
    navigate('/subscription')
  }, [navigate])

  if (!isPremium) {
    return (
      <Modal
        open
        onClose={handleClose}
        aria-labelledby="modal-subscription-title"
        aria-describedby="modal-subscription-description"
        sx={{ borderWidth: 0 }}>
        <Box
          sx={{
            width: { xs: '90%', sm: '40%' },
            maxWidth: 420,
            backgroundColor: 'white',
            top: '30%',
            left: '50%',
            transform: 'translateX(-50%)',
            position: 'absolute',
            borderRadius: 2,
            overflow: 'hidden'
          }}>
          <Box
            sx={{
              width: '100%',
              height: 56,
              backgroundColor: batikalColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1.1rem' }}>BatiKal</Typography>
          </Box>
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Typography id="modal-subscription-title" variant="h6" textAlign="center">
              L&apos;utilisation du service nécessite un abonnement
            </Typography>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{
                minWidth: 140,
                backgroundColor: sectionColors.S17COGENERATION,
                borderColor: sectionColors.S17COGENERATION
              }}>
              Fermer
            </Button>
          </Box>
        </Box>
      </Modal>
    )
  }

  return children
}

export default memo(RequireSubscription)
